import { getFeatureFlagVariant, watchFeatureFlagVariant } from "./posthog";

const AB_FLAG = "solutions-icon-style-v1";
const AA_FLAG = "solutions-icon-aa-v1";
let started = false;

export const initSolutionsIconExperiment = () => {
  const experiment = window.mtnSolutionsIconExperiment;
  if (
    started ||
    !experiment ||
    experiment.preview ||
    document.documentElement.dataset.scIcons !== "pending"
  ) {
    return;
  }
  started = true;
  const flag = experiment.aa ? AA_FLAG : AB_FLAG;
  const validVariants = experiment.aa
    ? ["control", "test"]
    : ["control", "emoji"];
  let stop = () => undefined;
  const cleanup = () => {
    stop();
    document.removeEventListener("mtn-solutions-icons-settled", cleanup);
  };
  document.addEventListener("mtn-solutions-icons-settled", cleanup);
  stop = watchFeatureFlagVariant(flag, (variant) => {
    if (!validVariants.includes(variant)) {
      experiment.settle();
      return;
    }
    if (experiment.settle(experiment.aa ? "control" : variant)) {
      // The first read was silent. Only applied assignments record exposure.
      getFeatureFlagVariant(flag, null);
    }
  });
  // onFeatureFlags may synchronously report an already-loaded assignment.
  if (document.documentElement.dataset.scIcons !== "pending") {
    cleanup();
  }
};
